import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=32e3ca7f&scoped=true"
import script from "./IssueList.vue?vue&type=script&lang=js"
export * from "./IssueList.vue?vue&type=script&lang=js"
import style0 from "./IssueList.vue?vue&type=style&index=0&id=32e3ca7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e3ca7f",
  null
  
)

export default component.exports